import { render, staticRenderFns } from "./SistemasExternosIcon.vue?vue&type=template&id=3a2cd737"
import script from "./SistemasExternosIcon.vue?vue&type=script&lang=js"
export * from "./SistemasExternosIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports